import i18next from "i18next";
import { withBreadCrumbs } from "lego-gui-lib";
import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { AreaSchema, EditAreaSchema } from "./schema";
import { CreateView, IndexView, ShowView } from "lego-gui-lib/lib";
import { ParentRoute } from "../../core/model/parent";
import { observer } from "mobx-react-lite";

export const Areas = {
  url: "/areas",
  handler: (props: RouteComponentProps<any>) => {
    const title = i18next.t("hns:area:domain_plural");
    const baseUrl = props.match.url;

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute path={baseUrl + "/:id"} dataSourceName={"area"} />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("area", "auth", "language", "i18n")(observer(comp));

const IndexSchema = AreaSchema;
export const Index = injectDataSource(({ area, i18n, auth, ...rest }: any) => {
  const title = i18n.t("hns:area:domain", { count: 2 });
  const allowed = auth.isAdmin();
  return (
    <IndexView
      dataSource={area.listDataSource}
      {...rest}
      title={title}
      toolbarButtons={{ delete: allowed, export: false }}
      rowButtons={{
        edit: allowed,
        delete: allowed,
        copy: allowed,
        export: allowed
      }}
      columns={IndexSchema}
    />
  );
});

export const Create = injectDataSource(
  ({ area, i18n, match, auth, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:area:domain" });
    const baseUrl = match.url;
    const history = useHistory();

    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={area.oneDataSource}
        {...rest}
        title={title}
        fields={AreaSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource((props: any) => {
  const { area, match, auth, i18n } = props;
  const title = i18n.t("common:edit", { domain: "hns:area:domain" });
  const baseUrl = match.url;
  const history = useHistory();

  const notAllowed = !auth.isAdmin();

  return withBreadCrumbs(
    { to: baseUrl + "/edit", children: title },
    <ShowView
      dataSource={area.oneDataSource}
      hideDeleteButton={notAllowed}
      title={title}
      fields={notAllowed ? EditAreaSchema.makeAllReadonly() : EditAreaSchema}
      id={match.params}
      preloadData={false}
      onlyView={notAllowed}
      goBack={() => history.goBack()}
    />
  );
});
